import React, { Fragment, useEffect, useState } from 'react'
import toast from 'react-hot-toast'

import styles from './EditGuide.module.css'

import Button from 'Design/components/Button'
import ConfirmationModal from 'Design/components/ConfirmationModal'

import StepEditor from '../StepEditor'
import GuidePreview from './GuidePreview'
import * as service from '../guides.service'
import { getSanitisedHtmlObj } from 'Utils/html'

const createMarkup = (content) => {
  return getSanitisedHtmlObj(content, [])
}

const Step = (props) => {
  const { guide, step = {}, currentStepId, setCurrentStepId, canDeleteStep, onCancelClick: cancel, mode } = props

  const [content, setContent] = useState(step.content)
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const [uploadImage, uploadImageResult] = service.useUploadImageMutation()
  const [createGuideStep, createGuideStepResult] = service.useCreateGuideStepMutation()
  const [updateGuideStep, updateGuideStepResult] = service.useUpdateGuideStepMutation()
  const [deleteGuideStep, deleteGuideStepResult] = service.useDeleteGuideStepMutation()

  useEffect(() => {
    setContent((currentContent) => {
      if (currentContent !== step.content) {
        return step.content
      }

      return currentContent
    })
  }, [step.content])

  const handleSaveClick = async () => {
    if (mode === 'create') {
      await createGuideStep({ guideId: guide.id, content })
      cancel()
      return
    }

    const updateGuidePromise = updateGuideStep({ id: step.id, guideId: guide.id, content })

    toast.promise(updateGuidePromise, {
      loading: 'Updating guide step',
      success: 'Guide step updated successfully',
      error: 'Unable to update step. Try again.'
    })

    await updateGuidePromise
  }

  const handleStepDelete = async () => {
    await deleteGuideStep({ guideId: guide.id, guideStepId: step.id })
    handleCloseDeleteModal()
    cancel()
  }

  const handlePreviewClick = (e) => {
    e.preventDefault()
    setCurrentStepId(step.id)
  }

  const handleCancelClick = () => {
    cancel()
  }

  const handleContentChange = (event) => {
    setContent(event.target.value)
  }

  const handleOpenDeleteModal = () => {
    setShowDeleteModal(true)
  }

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false)
  }
  // show preview
  if (currentStepId !== step.id && mode !== 'create') {
    return (
      <GuidePreview
        className={styles.GuideStepContent}
        key={step.id}
        dangerouslySetInnerHTML={createMarkup(step.content)}
        onClick={handlePreviewClick}
      />
    )
  }

  const isApiProgress =
    updateGuideStepResult.isLoading || deleteGuideStepResult.isLoading || createGuideStepResult.isLoading

  const disableSaveButton = uploadImageResult.isLoading
  const disableDeleteButton = isApiProgress || !step.id

  return (
    <Fragment>
      <ConfirmationModal
        isOpen={showDeleteModal}
        title='Delete Step'
        description='Are you sure to delete this step?'
        onCloseButtonClick={handleCloseDeleteModal}
        onConfirmButtonClick={handleStepDelete}
        confirmButtonText='Yes'
        cancelButtonText='No'
        disableConfirmButton={isApiProgress}
      />
      <StepEditor uploadImage={uploadImage} defaultValue={step.content} onChange={handleContentChange} autofocus />

      <div className={styles.ButtonContainer}>
        <Button variant='primary' type='submit' disabled={disableSaveButton} onClick={handleSaveClick}>
          Save
        </Button>

        <Button variant='link-muted' onClick={handleCancelClick}>
          Cancel
        </Button>

        {canDeleteStep && (
          <Button
            className={styles.DeleteButton}
            variant='link-danger'
            disabled={disableDeleteButton}
            onClick={handleOpenDeleteModal}
          >
            Delete
          </Button>
        )}
      </div>
    </Fragment>
  )
}

export default Step
